import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { BudgetHelper, DAILY_RANGE_ENTRY_MODE_DAILY } from '../../utils/BudgetHelper';
import { CurrencyHelper } from '../../utils/CurrencyHelper';

class BudgetPartialGoalsDailyRangeFeedbackClass extends Component {
    render() {
        const { t, totalBudget, budgetFromDate, budgetToDate, entries } = this.props;

        if (!entries || entries.length === 0) return null;
        const hasUsable = entries.some(e => {
            const amount = parseFloat(e.amount);
            if (isNaN(amount) || amount <= 0) return false;
            if (e.mode === DAILY_RANGE_ENTRY_MODE_DAILY) return !!e.date;
            return !!e.date_from && !!e.date_to;
        });
        if (!hasUsable) return null;

        const feedback = BudgetHelper.computeDailyRangeFeedback(totalBudget, budgetFromDate, budgetToDate, entries);
        const fmt = (v) => CurrencyHelper.formatNumberToCurrency(Math.round(v));

        return (
            <div className="daily-range-feedback" style={{ marginTop: '0.75em', padding: '0.5em 0.75em', backgroundColor: '#F9F9F9', borderRadius: '0.3em', fontSize: '0.9em' }}>
                <div>
                    <strong>{t('budget_partial_goals_daily_range_feedback.spike_total')}:</strong>{' '}
                    $ {fmt(feedback.spikeTotal)}
                    {' · '}
                    <strong>{t('budget_partial_goals_daily_range_feedback.baseline')}:</strong>{' '}
                    $ {fmt(feedback.dailyBaseline)} {t('budget_partial_goals_daily_range_feedback.per_day')}
                    {' '}
                    ({feedback.nonSpikeDays} {t('budget_partial_goals_daily_range_feedback.non_spike_days')})
                </div>
                {feedback.hasOverlaps && (
                    <div style={{ color: '#DF0D00', marginTop: '0.25em' }}>
                        {t('budget_partial_goals_daily_range_feedback.warning_overlaps')}
                    </div>
                )}
                {feedback.exceedsBudget && (
                    <div style={{ color: '#DF0D00', marginTop: '0.25em' }}>
                        {t('budget_partial_goals_daily_range_feedback.warning_exceeds')}
                    </div>
                )}
                {!feedback.exceedsBudget && feedback.dailyBaseline === 0 && feedback.nonSpikeDays > 0 && (
                    <div style={{ color: '#EC9F00', marginTop: '0.25em' }}>
                        {t('budget_partial_goals_daily_range_feedback.warning_zero_baseline')}
                    </div>
                )}
            </div>
        );
    }
}

export const BudgetPartialGoalsDailyRangeFeedback = withTranslation()(BudgetPartialGoalsDailyRangeFeedbackClass);
export default BudgetPartialGoalsDailyRangeFeedback;
